import { createModalsSlice, modalsInitialState } from '@sv-support-sdk/store';

const modals = createModalsSlice({
  name: 'modals',
  initialState: { ...modalsInitialState },
  reducers: {},
});

export const modalActions = modals.actions;

export default modals.reducer;
